module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-wrapper",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('br'), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    attrs: {
      "id": "current-tab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 rows-responsive"
  }, [_c('table', {
    staticClass: "invoices-table-sizes row-link table table-responsive analytic-rentals-table current-data-table"
  }, [_c('thead', [_c('tr', {
    staticClass: "title-current-tables rental-month"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.checking_today")))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.room")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.name")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.last_night")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.arrival_time")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.departure_time")))])])]), _vm._v(" "), _c('tbody', [(_vm.bookingsChecking.length == 0) ? _c('tr', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._l((_vm.bookingsChecking), function(booking, key) {
    return _c('tr', {
      staticClass: "td-responsive-styles",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(booking, booking.rental)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.rental.name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.checkout))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.time_in ? booking.time_in : '--'))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.time_out ? booking.time_out : '--'))])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 rows-responsive"
  }, [_c('table', {
    staticClass: "invoices-table-sizes row-link table table-responsive analytic-rentals-table current-data-table"
  }, [_c('thead', [_c('tr', {
    staticClass: "title-current-tables rental-month"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.checkout_today")))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.room")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.name")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.last_night")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.arrival_time")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.departure_time")))])])]), _vm._v(" "), _c('tbody', [(_vm.bookingsCheckout.length == 0) ? _c('tr', [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]) : _vm._l((_vm.bookingsCheckout), function(booking, key) {
    return _c('tr', {
      staticClass: "td-responsive-styles",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(booking, booking.rental)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.rental.name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.checkout))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.time_in ? booking.time_in : '--'))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.time_out ? booking.time_out : '--'))])])])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "invoices-table-sizes row-link table table-responsive analytic-rentals-table current-data-table"
  }, [_c('thead', [_c('tr', {
    staticClass: "title-current-tables rental-month"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.bookings_today")))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('booking.index.id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.rental')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.guest')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkin')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkout')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.nights')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.people')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.channel')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.status_title')))])])]), _vm._v(" "), _c('tbody', [(_vm.bookingsToday.length == 0) ? _c('tr', [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bookingsToday), function(booking, key) {
    return _c('tr', {
      staticClass: "td-responsive-styles",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(booking, booking.rental)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.id))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.rental.name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.checking))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.checkout))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-nights booking-detail"
    }, [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_c('i', {
      staticClass: "icon-rental-moon"
    }), _vm._v(" " + _vm._s(_vm._f("calculateNight")(booking.checking, booking.checkout)))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-people booking-detail"
    }, [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(" " + _vm._s(booking.nbr_adults))])]), _vm._v(" "), _c('td', {
      staticClass: "bookings-channel"
    }, [_c('div', {
      class: (booking.channel && booking.channel.logo === 'hotels2.png') ? 'hotels2' : 'd-flex justify-content-center align-items-center'
    }, [_c('img', {
      class: (booking.channel && booking.channel.logo) ? '' : 'default-rent',
      attrs: {
        "src": booking.channel && booking.channel.logo ? ("static/assets/images/" + (booking.channel.logo)) : '/static/assets/images/SuperHote_icons/rent.png'
      }
    })])]), _vm._v(" "), _c('td', [_c('div', [_c('span', {
      staticClass: "status-booking",
      class: _vm.getBookingClassName(booking.status, booking.statusCode, booking.payment_is_done)
    }, [_vm._v(_vm._s(_vm.getBookingStatusName(booking.status, booking.statusCode, booking.payment_is_done)))])])])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "invoices-table-sizes row-link table table-responsive analytic-rentals-table current-data-table"
  }, [_c('thead', [_c('tr', {
    staticClass: "title-current-tables rental-month"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.current_guests")))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.room")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.name")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.last_night")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.nbr_children")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.nbr_adults")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.channel')))])])]), _vm._v(" "), _c('tbody', [(_vm.currentGuests.length == 0) ? _c('tr', [_vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24)]) : _vm._l((_vm.currentGuests), function(booking, key) {
    return _c('tr', {
      staticClass: "td-responsive-styles",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(booking, booking.rental)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.rental.name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.checkout))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(_vm._s(booking.nbr_children))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(_vm._s(booking.nbr_adults))])]), _vm._v(" "), _c('td', {
      staticClass: "bookings-channel"
    }, [_c('div', {
      class: (booking.channel && booking.channel.logo === 'hotels2.png') ? 'hotels2' : 'd-flex justify-content-center align-items-center'
    }, [_c('img', {
      class: (booking.channel && booking.channel.logo) ? '' : 'default-rent',
      attrs: {
        "src": booking.channel && booking.channel.logo ? ("static/assets/images/" + (booking.channel.logo)) : '/static/assets/images/SuperHote_icons/rent.png'
      }
    })])])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "invoices-table-sizes row-link table table-responsive analytic-rentals-table"
  }, [_c('thead', [_c('tr', {
    staticClass: "title-current-tables rental-month"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("analytics.index.current_tab.last_bookings")))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('booking.index.id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.rental')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.guest')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkin')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkout')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.nights')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.people')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.channel')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.status_title')))])])]), _vm._v(" "), _c('tbody', [(_vm.lastBookings.length == 0) ? _c('tr', [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lastBookings), function(booking, key) {
    return _c('tr', {
      staticClass: "td-responsive-styles",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(booking, booking.rental)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.id))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.rental.name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.checking))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_vm._v(_vm._s(booking.checkout))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-nights booking-detail"
    }, [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_c('i', {
      staticClass: "icon-rental-moon"
    }), _vm._v(" " + _vm._s(_vm._f("calculateNight")(booking.checking, booking.checkout)))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-people booking-detail"
    }, [_c('div', {
      staticClass: "analytics-rental-divs"
    }, [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(" " + _vm._s(booking.nbr_adults))])]), _vm._v(" "), _c('td', {
      staticClass: "bookings-channel"
    }, [_c('div', {
      class: (booking.channel && booking.channel.logo === 'hotels2.png') ? 'hotels2' : 'd-flex justify-content-center align-items-center'
    }, [_c('img', {
      class: (booking.channel && booking.channel.logo) ? '' : 'default-rent',
      attrs: {
        "src": booking.channel && booking.channel.logo ? ("static/assets/images/" + (booking.channel.logo)) : '/static/assets/images/SuperHote_icons/rent.png'
      }
    })])]), _vm._v(" "), _c('td', [_c('div', [_c('span', {
      staticClass: "status-booking",
      class: _vm.getBookingClassName(booking.status, booking.statusCode, booking.payment_is_done)
    }, [_vm._v(_vm._s(_vm.getBookingStatusName(booking.status, booking.statusCode, booking.payment_is_done)))])])])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bookingDetails),
      expression: "bookingDetails"
    }],
    staticClass: "calendar-month-view"
  }, [_c('div', {
    staticClass: "panel panel-white left"
  }, [_c('div', {
    staticClass: "pannel_sec"
  }, [_c('div', {
    staticClass: "cross_icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeDetailModal()
      }
    }
  }, [_vm._v(" x ")]), _vm._v(" "), _c('div', {
    staticClass: "pannel_details"
  }, [_c('h2', {
    staticClass: "tle_p"
  }, [_c('div', {
    staticClass: "event-fullname"
  }, [_vm._v("\n                    " + _vm._s(_vm.guestItem.first_name ? _vm.guestItem.first_name : '') + " " + _vm._s(_vm.guestItem.last_name ? _vm.guestItem.last_name : '') + "\n                  ")]), _vm._v(" "), _c('span', [_vm._v("("), _c('span', {
    staticClass: "event-bookingid"
  }, [_vm._v(_vm._s(_vm.bookingItem.id))]), _vm._v(") ")])]), _vm._v(" "), _c('div', {
    staticClass: "c_date c_date_a"
  }, [_c('p', {
    staticClass: "margin-bottom-10"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.rental_name')) + " : "), _c('span', [_vm._v(_vm._s(_vm.rentalItem.name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.booking_date')) + " : "), (_vm.bookingItem.booking_date) ? _c('span', {
    staticClass: "event-checkin"
  }, [_vm._v(_vm._s(_vm._f("getWeekDayFromDateCalendar")(_vm.bookingItem.booking_date)))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.checkin')) + " : "), (_vm.bookingItem.checking) ? _c('span', {
    staticClass: "event-checkin"
  }, [_vm._v(_vm._s(_vm.bookingItem.checking))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "margin-bottom-10"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.checkout')) + " : "), (_vm.bookingItem.checkout) ? _c('span', {
    staticClass: "event-checkout"
  }, [_vm._v(_vm._s(_vm.bookingItem.checkout))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "event_referer"
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-10"
  }, [_c('span', {
    staticClass: "event-adults"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('calendar.booking-detail.nb_adults')) + " : " + _vm._s(_vm.bookingItem.nbr_adults) + "\n                      ")]), _vm._v("\n                      -\n                      "), _c('span', {
    staticClass: "event-children"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.nb_children')) + " : " + _vm._s(_vm.bookingItem.nbr_children))])]), _vm._v(" "), (_vm.bookingItem.booking_com_res_id) ? _c('p', {
    staticClass: "margin-bottom-10"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.reservation_status")) + " : "), _c('span', [_vm._v(_vm._s(_vm.getReservationStatusName(_vm.bookingItem.reservation_status)))])]) : _vm._e(), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.showBookingPrices) || !_vm.account.is_team_member) ? _c('div', {
    staticClass: "margin-bottom-15 price"
  }, [_vm._v("\n                      " + _vm._s(_vm.getBookingChannelName(_vm.channelItem, _vm.bookingItem.original_referrer, _vm.bookingItem.ical)) + "\n                      "), _c('span', [_vm._v("("), _c('span', [_vm._v(_vm._s(_vm.getPriceAmount(_vm.bookingItem)))]), _vm._v(" " + _vm._s(_vm.rentalItem.currency ? _vm.rentalItem.currency.symbol : '€') + ")")]), _vm._v(" "), (_vm.bookingUrl) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.bookingUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.booking_page')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member || (_vm.user.is_team_member && _vm.user.rights && _vm.showBookingActions)) ? _c('p', {
    class: _vm.isExtraDataLong(_vm.bookingItem.extra_data_from_form) ? 'overflow-panel-notes panel-notes' : 'panel-notes'
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('input.notes')) + " :\n                      "), _c('span', [_vm._v(_vm._s(_vm.getBookingExtraDetails(_vm.bookingItem.extra_data_from_form)))])]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member || (_vm.user.is_team_member && _vm.user.rights && _vm.showBookingActions)) ? _c('p', {
    class: _vm.isExtraDataLong(_vm.bookingItem.extra_data_from_form, 'comments') ? 'overflow-panel-notes panel-notes margin-bottom-10' : 'panel-notes margin-bottom-10'
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('booking.detail.events.comments')) + " :\n                      "), _c('span', [_vm._v(_vm._s(_vm.getBookingExtraDetails(_vm.bookingItem.extra_data_from_form, 'comments')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form_group_attached"
  }, [_c('div', {
    staticClass: "form_group_half"
  }, [_c('div', {
    staticClass: "form_group form_group_half_col"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.arrival')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-arrival"
  }, [_vm._v(_vm._s(_vm.bookingItem.time_in ? _vm.bookingItem.time_in : 'N/A'))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.departure')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-arrival"
  }, [_vm._v(_vm._s(_vm.bookingItem.time_out ? _vm.bookingItem.time_out : 'N/A'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.email')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-email"
  }, [_vm._v(_vm._s(_vm.guestItem.email ? _vm.guestItem.email : 'N/A'))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.mobile')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-phone"
  }, [_vm._v(_vm._s(_vm.guestItem ? _vm.guestItem.phone : 'N/A'))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group_half form-control-margin-0"
  }, [_c('div', {
    staticClass: "form_group form_group_half_col"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.payment')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-payment"
  }, [_vm._v(_vm._s(_vm.bookingItem.status === 1 && _vm.bookingItem.payment_is_done === 1 ? 'OK' : 'KO'))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col form-group-default"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.deposit')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-deposit"
  }, [_vm._v(_vm._s(_vm.bookingItem.statusCode !== 14 && _vm.bookingItem.deposit_is_done === 1 ? 'OK' : 'KO'))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col form-group-default"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.welcome_form_submitted")) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.welcome_form_submitted),
      expression: "bookingItem.welcome_form_submitted"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "welcome_form_submitted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.changeFormStatus('welcome', _vm.bookingItem)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("KO")])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col form-group-default"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.checkin_form_submitted")) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.checkin_form_submitted),
      expression: "bookingItem.checkin_form_submitted"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "checkin_form_submitted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.changeFormStatus('checkin', _vm.bookingItem)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("KO")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form_group_half_col form-group-default"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('label', {
    staticClass: "fade booking-status"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.to_throw_back')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "title": _vm.$t('calendar.booking-detail.follow_up_info')
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.follow_up),
      expression: "bookingItem.follow_up"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "follow_up", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onChangeFollowUp()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.yes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.no')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form_group_half_col form-group-default"
  }, [_c('div', {
    staticClass: "d-flex contract-status"
  }, [_c('label', {
    staticClass: "booking-status"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.contract.title')) + " ")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "box"
  }, [_vm._v(_vm._s(_vm.bookingItem.is_booking_contract_signed ? _vm.$t('booking.detail.signed') : _vm.$t('booking.detail.not_signed')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group_half form-control-margin-0"
  }, [_c('div', {
    staticClass: "form_group form-group-default form_group_half_col border-top-0"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('account.users.teamMember.assignCheckin')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.assigned_to_checking),
      expression: "bookingItem.assigned_to_checking"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "assigned_to_checking", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.addOrChangeTeamMember(_vm.bookingItem.id, _vm.bookingItem.assigned_to_checking, 'checking')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-")]), _vm._v(" "), _vm._l((_vm.membersForChecking), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v(_vm._s(((member.first_name) + " " + (member.last_name))))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form_group form-group-default form_group_half_col border-top-0"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('account.users.teamMember.assignCheckout')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.assigned_to_checkout),
      expression: "bookingItem.assigned_to_checkout"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "assigned_to_checkout", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.addOrChangeTeamMember(_vm.bookingItem.id, _vm.bookingItem.assigned_to_checkout, 'checkout')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-")]), _vm._v(" "), _vm._l((_vm.membersForCheckout), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v(_vm._s(((member.first_name) + " " + (member.last_name))))])
  })], 2)])])]), _vm._v(" "), (!_vm.user.is_team_member || (_vm.user.is_team_member == 1 && _vm.user.rights && _vm.showBookingActions)) ? _c('div', {
    staticClass: "other-actions"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bookingItem.areLocksConnectedToBookingRental && !_vm.user.is_team_member),
      expression: "bookingItem.areLocksConnectedToBookingRental && !user.is_team_member"
    }],
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openModal('#controlLocks-modal')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t('rentals.detail.locks_management')))]), _vm._v(" "), _vm._m(34)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.bookingItem.id, 'invoices')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("button.view_invoice")))]), _vm._v(" "), _vm._m(35)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.bookingItem.id, 'payments')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("button.view_payment")))]), _vm._v(" "), _vm._m(36)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.bookingItem.id, 'contract')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.contract.title")))]), _vm._v(" "), _vm._m(37)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.bookingItem.id, 'messages')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("button.view_messages")))]), _vm._v(" "), _vm._m(38)])]) : _vm._e(), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.showBookingPrices && _vm.showBookingActions) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "btnn"
  }, [_c('button', {
    staticClass: " btn waves-effect waves-classic button-booking-detail p-0",
    attrs: {
      "id": "eventSave"
    },
    on: {
      "click": function($event) {
        _vm.toBooking(_vm.bookingItem.id, 'informations', true)
      }
    }
  }, [_c('a', {
    staticClass: "button-booking-detail",
    attrs: {
      "href": ("#/bookings/" + (_vm.bookingItem.id) + "/informations")
    }
  }, [_vm._v(_vm._s(_vm.$t('button.booking_details')))])])]) : _vm._e()])])]), _vm._v(" "), _c('v-manage-locks', {
    attrs: {
      "rental": Object.assign({}, _vm.bookingItem.rental),
      "booking": Object.assign({}, _vm.bookingItem)
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "last-child-td"
  }, [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "last-child-td"
  }, [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "last-child-td"
  }, [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "last-child-td"
  }, [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "last-child-td"
  }, [_c('div', {
    staticClass: "analytics-rental-divs"
  }, [_vm._v("--")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon icon-padding-none md-chevron-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon icon-padding-none md-chevron-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon icon-padding-none md-chevron-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon icon-padding-none md-chevron-right"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee8a5d18"}!./src/app/pages/analytics/current/current.html
// module id = 1463
// module chunks = 0